<template>
  <v-container fluid>
   <v-row>
      <v-col cols="12" xs="12">
        <v-toolbar flat width="100%">
          <v-toolbar-title class="pl-3 banner-title blue--text"
            >
            Items</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <div>
            <newItem class="pr-3" />
          </div>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-col cols="12">
      <v-data-table
        :headers="header"
        item-key="id"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :items="items"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            label="Search"
            class="mx-4"
          ></v-text-field>
        </template>

        <template v-slot:[`item.actions`]="item">
          <v-menu bottom left>
          <template v-slot:activator="{ on }">
            <v-icon small class="mr-2;" style="cursor: pointer" v-on="on">
              mdi-dots-vertical
            </v-icon>
          </template>
            <v-list>
              <v-list-item v-for="(it, i) in menu_items" :key="i">
                <v-list-item-title style="cursor: pointer;" class="" @click="doAction({ name: it.ref, item: item })">
                    {{ it.title }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <!--
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <div class="text-center" style="padding: 100px" v-if="expanding">
              <v-progress-circular
                :size="70"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </div>
            <v-simple-table
              style="background-color: transparent"
              v-if="expandedItem && !expanding"
            >
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>Status</td>
                    <td align="right">{{ expandedItem.status }}</td>
                  </tr>
                  <tr>
                    <td>Date</td>
                    <td align="right">{{ expandedItem.date }}</td>
                  </tr>
                  <tr>
                    <td>To</td>
                    <td align="right">{{ expandedItem.name }}</td>
                  </tr>
                  <tr v-if="transactionType === 'AIRTIME'">
                    <td>mobile</td>
                    <td align="right">{{ item.description }}</td>
                  </tr>
                  <tr v-if="transactionType === 'CASHPOWER'">
                    <td>Meter Number</td>
                    <td align="right">{{ expandedItem.meterNumber }}</td>
                  </tr>
                  <tr v-if="transactionType === 'CASHPOWER'">
                    <td>Token</td>
                    <td align="right">{{ expandedItem.token }}</td>
                  </tr>
                  -->
                  <!-- <tr>
          <td>status</td>
          <td>completed</td>
        </tr> -->
        <!--
                  <tr align="right">
                    <td align="right" :colspan="headers.length">
                      <v-btn
                        :loading="
                          buyCashpowerBtnLoading &&
                          activeItem &&
                          item.item &&
                          activeItem.id == item.item.id
                        "
                        class="ma-2"
                        outlined
                        color="green"
                        @click="buy(item)"
                      >
                        Buy Again
                      </v-btn>
                      <v-btn
                        class="ma-2"
                        outlined
                        color="red"
                        v-if="transactionType === 'CASHPOWER'"
                        @click="resendToken(item)"
                      >
                        Resend
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </td>
        </template>
        -->
      </v-data-table>
    </v-col>
  </v-container>
</template>

<script>
 const newItem = () => import("./item-add-form");
//import { createNamespacedHelpers } from "vuex";
export default {
  components: {
    newItem,
  },
  data: () => ({
    activeItem: null,
    menu: null,
    show: false,
    expanded: [],
    filteredTransactions: null,
    search: "",
    //: false,
    expandedItem: null,
    expanding: false,
    menu_items: [
      {title: "view item", ref: "view_item"},
      {title: "edit item", ref: "edit_item"}
    ]
  }),

  computed: {
    /*...transactionsNamespace.mapState({
      transactions: (state) => state.transactions,
      transactionType: (state) => state.transactionType,
      loading: (state) => state.loading,
      transactionsDialog: (state) => state.transactionsDialog,
      transactionsParam: (state) => state.transactionsParam,
      transactionsDialogKey: (state) => state.transactionsDialogKey,
    }),*
    */
    items() {
      return [
        {item_name: "nike free run", item_description: "desc test", price: "200"},
        {item_name: "adidas boost", item_description: "desc test two", price: "130"}
      ]
    },
    header() {
      return [
        { text: "Item Name", value: "item_name" },
        { text: "Description", value: "item_description" },
        { text: "Price", value: "price" },
        { text: "Action", value: "actions", align: "end", sortable: false }
      ];
    },
  },
  mounted() {
   // this.loadTransactions();
    console.log("loading", this.loading);
  },
  methods: {
    //...airtimeNamespace.mapMutations(["mBuyAirtime"]),
    //...transactionsNamespace.mapActions(["aLoadTransactionDetails"]),
   // ...transactionsNamespace.mapMutations(["mSetTransactionType"]),
    //...cashpowerNamespace.mapMutations(["mBuyCashpower", "mSetResend"]),
    //...cashpowerNamespace.mapActions(["aGetPaymentIntentUsingSecret"]),
    /*async expand({ item, value }) {
      this.$log.debug("item", item);
      this.$log.debug("opened", value);
      if (value) {
        this.expanding = true;
        this.expandedItem = null;
        await this.aGetPaymentIntentUsingSecret(item.secret);
        if (this.nawecToken) {
          const intent = this.nawecToken;
          const apiMessage = JSON.parse(intent.apiMessage);
          // console.log("nawec token", this.nawecToken);
          const d = {
            name: item.name,
            meterNumber: apiMessage.request.meterNumber,
            amount: apiMessage.request.amount,
            mobile: apiMessage.request.mobile,
            secret: intent.secret,
            token: intent.token,
          };
          this.expandedItem = { ...item, ...d };
        }

        // expandedItem: null,
        // expanding: false,

        this.expanding = false;
      }
    },
    async resendToken(item) {
      // console.log("resend", this.resend);
      await this.mSetResend(true);
      console.log("resend1", this.resend);
      this.buyCashpower(item);
    },
    async buyCashpower(item) {
      this.buyCashpowerBtnLoading = true;
      // console.log("item", item);
      await this.aGetPaymentIntentUsingSecret(item.secret);

      if (this.nawecToken) {
        const apiMessage = JSON.parse(this.nawecToken.apiMessage);
        // console.log("nawec token", this.nawecToken);
        const payload = {
          name: item.name,
          meterNo: apiMessage.request.meterNumber,
          amount: apiMessage.request.amount,
          mobile: apiMessage.request.mobile,
          secret: item.secret,
        };
        this.buyCashpowerBtnLoading = false;
        this.mBuyCashpower(payload);
      }
    },
    buy(item) {
      this.activeItem = item;
      if (this.transactionType === "CASHPOWER") {
        this.buyCashpower(item);
      } else if (this.transactionType === "AIRTIME") {
        this.mBuyAirtime(item);
      }
    },
    getMeterNo() {
      console.log("get mater number");
      if (this.transactions) {
        this.filteredTransactions = this.transactions.map((item) => {
          return {
            name: item.name,
            meterNo: this.aGetPaymentIntentUsingSecret(item.secret).request
              .meterNumber,
            date: item.date.getDate(),
            amount: "GMD" + item.amount,
          };
        });
      }
      console.log("filtered transactions", this.filteredTransactions);
    },
    async loadTransactions() {
      console.log("trans..........");
      if (this.transactionType) {
        // console.log("payload", this.transactionType)
        await this.aLoadTransactionDetails(this.transactionType);
      }
    },*/
    doAction(item){
      console.log('action', item)
    },
    filterOnlyCapsText(value, search) {
      return (
        value != null &&
        search != null &&
        typeof value === "string" &&
        value.toString().indexOf(search) !== -1
      );
    },

    initialize() {
      this.desserts = [
        {
          name: "Frozen Yogurt",
          calories: 159,
          fat: 6.0,
          carbs: 24,
          protein: 4.0,
        },
        {
          name: "Ice cream sandwich",
          calories: 237,
          fat: 9.0,
          carbs: 37,
          protein: 4.3,
        }
      ];
    },
  },
};
</script>

<style scoped>
.transactions {
  width: 100%;
}
</style>